<div id="entire_loader">
    <img class="logo" src="../../../assets/app/logo.png" alt="">
    <!-- <div class="lds-ring"><div></div><div></div><div></div><div></div></div> -->
</div>